export default "__VITE_ASSET__c7578a19__"